import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal, DatePicker, Viewer, Tooltip } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { DriverService } from 'services';
import moment from 'moment';
import { ViewIcon, UserIcon } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any;
	item: any;
}

class ModalViewFiles extends React.Component<Props> {

	state = {
		visible: false,
		file: null,
		driver: null
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await DriverService.view({
			driver_id: this.props.item?.id
		});
		this.setState({
			driver: res.driver
		});
	}

	viewFile = (e: any, file: string) => {
		e.preventDefault();
		this.setState({
			file,
			visible: true
		});
	}

	render() {
		const { visible } = this.state;
		const driver: any = this.state.driver;

		const FILES = [
			{
				file: Constants.DOCUMENT_TYPES.PHOTO,
				name: 'Foto de Perfil'
			},
			{
				file: Constants.DOCUMENT_TYPES.MEDICAL_CERTIFICATE,
				name: 'Certificado de Salud'
			},
			{
				file: Constants.DOCUMENT_TYPES.FOOD_HANDLING,
				name: 'Certificado de manipulación de alimentos'
			},
			{
				file: Constants.DOCUMENT_TYPES.LICENSE,
				name: 'Licencia de conducir'
			},
			{
				file: Constants.DOCUMENT_TYPES.RIF,
				name: 'RIF'
			},
			{
				file: Constants.DOCUMENT_TYPES.ID,
				name: 'Cédula'
			}
		]

		return (
			<div id="modal-view-driver-files">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setState({ visible: false }) }
			      images={ [{ src: this.state.file }] }
			    />

				<div className="row">
					{
						FILES.map((file: any) => {
							const _file = driver?.user_documents?.find((i: any) => i.document_type_id == file?.file)?.file;

							if (_file)
								return (
									<div className="col-md-6" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
										<div className={ `photo-wrapper-file document-photo ${ _file?.endsWith('.pdf') ? 'pdf' : '' }` }>
											{
												driver != null && (
													<a href="#" onClick={ (e: any) => this.viewFile(e,Constants.BASE_STORAGE + _file) }>
														<FallbackImage
															src={ Constants.BASE_STORAGE + _file }
															placeholder={UserIcon}
															className="fb-img"
															placeholderClassName="fb-img-placeholder"
														/>
													</a>
												)
											}
										</div>
										<p className="card-foot">
											{ file.name }
											{
												_file?.endsWith('.pdf') && (
													<Tooltip title="Ver">
														<a href={ Constants.BASE_STORAGE + _file } target="_blank">
															<img src={ ViewIcon } className="view-icon" />
														</a>
													</Tooltip>
												)
											}
										</p>
									</div>
								)
						})
					}
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalViewFiles);